export default __webpack_public_path__ + "static/media/logo_white.6fd2df8c.png";